export default "__VITE_ASSET__MEdZKs8q__"